import { createAction } from '@ngrx/store';

export const onDestroySheetPage = createAction(
  '[SHEET PAGE ACTION] on destroy sheet page'
);
